import { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { HomePage } from './pages/HomePage'

const SanctuaryPage = lazy(() => import('./pages/SanctuaryPage').then(({ SanctuaryPage }) => ({ default: SanctuaryPage })))
const CommunityPage = lazy(() => import('./pages/CommunityPage').then(({ CommunityPage }) => ({ default: CommunityPage })))
const EventsPage = lazy(() => import('./pages/EventsPage').then(({ EventsPage }) => ({ default: EventsPage })))
const GalleryPage = lazy(() => import('./pages/GalleryPage').then(({ GalleryPage }) => ({ default: GalleryPage })))
const JoinPage = lazy(() => import('./pages/JoinPage').then(({ JoinPage }) => ({ default: JoinPage })))
const AdminPage = lazy(() => import('./pages/AdminPage').then(({ AdminPage }) => ({ default: AdminPage })))
const NotFoundPage = lazy(() => import('./pages/NotFoundPage').then(({ NotFoundPage }) => ({ default: NotFoundPage })))

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="/sanctuary" element={<SanctuaryPage />} />
        <Route path="/community" element={<CommunityPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/join" element={<JoinPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}
